import {
  observable,
  action
} from 'mobx';
import {
  message
} from 'antd';
import base from '../../tool/base';
import util from '../../util/index';
const {
  catchApiError,
  getAccessToken
} = util;
export class AppCollectStore {
  constructor(routing) {
    this.routing = routing;
  }
  @observable collectList = [];
  @observable collectCount = [];
  @observable current = 1;
  @observable pageSize = 21;
  @observable moduleType = '';
  @observable loading = false;
  @observable searchValue = "";

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }

  @action
  getMould = (id) => {
    if (id === 'mode') return 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7';
    else if (id === 'dev') return 'c2ad5184-3e3e-431f-947e-67ae3a960b59';
    else if (id === 'nStandard') return '5058eb5e-8087-4c0d-8a64-3fa600862c02';
    else if (id === 'theme') return '8f16dc55-7b76-4786-97a8-8b9ecd0da935';
    return '';
  }

  @action
  getCollectList = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      collect: 0,
      module: params.module || this.moduleType,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/appCon', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          this.collectList = param.current === 1 ? data.apps : this.collectList.concat(data.apps);
          this.collectCount = data.count;
          resolve(data);
        }
        this.loading = false;
      });
    });
  }

  @action
  callCollect = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      cloudStore: 1,
      ...params,
    };
    return new Promise(resolve => {
      base.callApi('/v3/appcollect/edit4batch', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          message.success(param.collect === '0' ? '收藏成功' : '取消收藏成功');
          resolve(data);
        } else {
          message.success(param.collect === '0' ? '收藏失败' : '取消收藏失败');
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/collect/AppCollectStore.js